module.exports = __webpack_public_path__ + "img/logoc.731ab0bf.png";